import * as React from "react";
import { AlertCircle, CheckCircle, AlertTriangle, XCircle } from "lucide-react";
import { StatusComponentProps } from "./status.types";
import { WorkflowStatus } from "@prisma/client";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"
const StatusIcons: Record<WorkflowStatus, { component: React.ComponentType, color: string }> = {
  PENDING: { component: AlertTriangle, color: "#FFA500" }, // Orange (Pending)
  COMPLETED: { component: CheckCircle, color: "#32CD32" }, // LimeGreen (Completed)
  MISSING: { component: AlertCircle, color: "#FF4500" }, // OrangeRed (Missing)
  MISTAKE: { component: XCircle, color: "#FF0000" }, // Red (Mistake)
};

const Status: React.FC<StatusComponentProps> = ({ status }) => {
  return (
    (<div className="status-component flex items-center">
      <StatusIcon status={status} enableTooltip={false} />
      <span className="capitalize truncate">{status.replace(/_/g, ' ').toLowerCase()}</span>
    </div>)
  );
};

const StatusIcon: React.FC<StatusComponentProps> = ({ status, enableTooltip = true }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const IconComponent = (StatusIcons[status]?.component as React.ComponentType<any>);
  const color = StatusIcons[status]?.color;
  return enableTooltip ? <TooltipProvider delayDuration={0}>
  <Tooltip >
    <TooltipTrigger tabIndex={-1}>{
      IconComponent ? (
        <span className="mr-2 flex items-center" style={{ color }}>
          <IconComponent className="w-4 h-4" />
        </span>
      ) : '?'
  }</TooltipTrigger>
    <TooltipContent side="left" >
      <p className="capitalize truncate">{status.replace(/_/g, ' ').toLowerCase()}</p>
    </TooltipContent>
  </Tooltip>
</TooltipProvider> : IconComponent ? (
  <span className="mr-2 flex items-center" style={{ color }}>
    <IconComponent className="w-4 h-4 self-center align-middle" />
  </span>
) : null;
};
  

export { Status, StatusIcon };
